import Vue from 'vue'
import { mapActions } from 'vuex'

export default {
  ...mapActions(['updateEditedComponentName']),

  getParentObject(vueComponent) {
    if (vueComponent.parentObject != null) {
      return vueComponent.parentObject
    } else {
      return vueComponent.root.inputs
    }
  },

  updateExoInput(vueComponent, selectedItem) {
    let existingObject = vueComponent.getParentObject[vueComponent.name]
    //editing item different from current one -> replace the current one
    if (selectedItem != null && existingObject?.id != selectedItem.value?.id) {
      existingObject = selectedItem.value
    }
    //creating new item
    if (selectedItem == null) {
      existingObject = null // reset ref to set it later when coming back from waterfall
    }
    this.saveEditedComponentName(vueComponent)
    return existingObject
  },

  updateExoInputMultiple(vueComponent, selectedItem) {
    let existingObjectList = vueComponent.getParentObject[vueComponent.name]
    //if list of items is null: initialize
    if (existingObjectList == null) {
      existingObjectList = []
    }

    //editing item
    if (selectedItem != null) {
      let itemInList = false
      let itemListLength = existingObjectList.length
      //if other items in the list, check if the edited one is in the list
      if (itemListLength !== 0) {
        for (let index = 0; index < itemListLength; index++) {
          if (existingObjectList[index].id === selectedItem.value.id) {
            itemInList = true
            break
          }
        }
      }
      if (!itemInList) {
        existingObjectList.push(selectedItem.value)
      }
    }
    this.saveEditedComponentName(vueComponent)
    return existingObjectList
  },

  nbCols(vueComponent) {
    return vueComponent.alignWithParametricField === true ? '9' : '11'
  },

  styleObject(vueComponent) {
    if (!vueComponent.hoverState) {
      return {}
    }
    if (vueComponent.$vuetify.theme.dark === false) {
      return {
        backgroundColor: '#f5f5f5'
      }
    } else {
      return {
        backgroundColor: '#353535'
      }
    }
  },

  saveEditedComponentName(vueComponent) {
    let editedComponent = vueComponent.editedComponentName
    if (editedComponent == null) {
      editedComponent = {}
    }
    editedComponent[vueComponent.root.getCurrentFormType()] = vueComponent.name
    vueComponent.updateEditedComponentName(editedComponent)
  },

  setPathToComeBack(vueComponent, item) {
    let history = JSON.parse(localStorage.getItem('history') || '[]')
    let newHistoryObj = {
      routeName:
        vueComponent.root.getCurrentFormTitle() === 'Simulator Mission'
          ? 'SimulatorRequest'
          : vueComponent.root.getCurrentFormType(),
      id: vueComponent._uid
    }
    history.push(newHistoryObj)
    localStorage.setItem('history', JSON.stringify(history))
    vueComponent.$router.push(vueComponent.componentRoute)
    Vue.nextTick(() => {
      vueComponent.$root.$emit('current-mission-updated')
      if (item) {
        vueComponent.$root.$emit(
          'open-dialog',
          vueComponent.$router.currentRoute.name,
          item.value
        )
      } else {
        vueComponent.$root.$emit(
          'open-dialog',
          vueComponent.$router.currentRoute.name
        )
      }
    })
  }
}
